import {z} from 'zod';

import {
  extractDeliveryNoteDocumentOpenAIResultSchema,
  extractDeliveryNoteDocumentItemSchema,
} from './ExtractDeliveryNoteDocumentOpenAIResult';

const itemSchema = extractDeliveryNoteDocumentItemSchema.extend({
  discount: z.number().nullable(),
});

export const extractDeliveryNoteDocumentResultSchema =
  extractDeliveryNoteDocumentOpenAIResultSchema.extend({
    listOfItems: z.array(
      z.object({
        items: z.array(itemSchema),
        pageNumber: z.number(),
      })
    ),
  });

export type ExtractDeliveryNoteDocumentResult = z.infer<
  typeof extractDeliveryNoteDocumentResultSchema
>;
